var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebBrowser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.23,163V55.72a4.82,4.82,0,0,1,4.69-4.94H178.43a4.82,4.82,0,0,1,4.69,4.94V163Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 32.24,
    y1: 81.25,
    x2: 183.11,
    y2: 81.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.27,65.44a3.06,3.06,0,1,1-3.06-3,3,3,0,0,1,3.06,3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.06,65.44a3.06,3.06,0,1,1-3.06-3,3,3,0,0,1,3.06,3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.85,65.44a3.06,3.06,0,1,1-3.06-3,3,3,0,0,1,3.06,3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebBrowser);
export default __webpack_public_path__ + "static/media/WEB_BROWSER.00ddbf78ebf2bbf8d5afa4df92f0f5c9.svg";
export { ForwardRef as ReactComponent };